import React from 'react'
import Header from '../Menpages/Header/Main'
import Bredcom from '../MenTeam/Bredcom'
import Aboutcompany from '../MenTeam/Aboutcompany'
import Ourteem from '../MenTeam/Ourteem'
import Free from '../MenTeam/Free'
import Slider from '../Menpages/GlobleSlider/Main'
import Footer from '../Menpages/Footer/Main'

function Main() {
  
  return (
    <>
        <div className="page-wrapper">
            <Header/>
            <Bredcom title={"Home"} head={"Team Member"} sbtitle={"Team Member"}/>
            <Aboutcompany/>
            <Ourteem/>
            <Free/>
            <Slider/>
            <Footer/>
        </div>
    </>
  )
}

export default Main